module.exports = __webpack_public_path__ + "img/actual.82515db4.svg";